export default "__VITE_ASSET__B5ij44ll__"